import { enableProdMode, getPlatform, provideZoneChangeDetection, Type } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { environment } from '@se-po/shared-environments'

export const bootstrapModuleV2 = <T>(module: Type<T>, options?: any): void => {
  let platform = getPlatform()
  const mergedOptions = {
    ...options,
    applicationProviders: [
      provideZoneChangeDetection(),
      ...(options?.applicationProviders ?? [])
    ]
  }

  if (!platform) {
    if (environment.production) enableProdMode()
    platform = platformBrowserDynamic()
  }

  platform.bootstrapModule(module, mergedOptions).catch(err => console.error(err))
  const lib = (window as any)._?.noConflict()
  if (!(window as any)._) {
    ;(window as any)._ = lib; // ensure we are not overwriting the host apps lodash version
  }
}
